import {IntermediatePart} from "../../parts/intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";

export default class SmallCornerShelf extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'small_corner_shelf';
    this.partName = 'Small Corner Shelf';
    this.translateId = "visualizer.bathroom.accessories.small_corner_shelf";
    this.visible = true;
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new SmallCornerShelf());
  }

  handleClick() {
    const accessoriesParent = this.getParent().getParent();
    accessoriesParent.caddie_type = this.partId;
    super.handleClick();
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  setLayers(layout) {

    const accessoriesParent = this.getParent();
    if (accessoriesParent.caddie_type !== this.partId) {
      super.hideLayers();
      return;
    }

    const conditions = this.getArrayOfConditions();
    if ((this.activeFeature && this.activeFeature.matchesMetaForArrayOfConditions(conditions)
      || (this.activeFeature && this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    const accParent = this.getParent();
    const showerParent = accParent.layout.parts[Shower.id];
    const activeShowerPartId = showerParent && showerParent.showerTubComboIsActive() ? ShowerTubCombo.id : Shower.id;
    const showerSize = showerParent.layout.parts[activeShowerPartId].showerSize();
    return [{
      propName: 'ShowerSize',
      propValue: showerSize
    }]
  }

  setDefault() {
    const filteredFeatures = this.features.filter(f => f.matchesMetaForArrayOfConditions(this.getArrayOfConditions()));
    if (!super.tryToSetTheSameFeature(filteredFeatures, '', '', true)) {
      const placeholderDefault = filteredFeatures.find((feature) => {
        return feature.dbFeature.displayName && feature.dbFeature.displayName.includesCI(" - Placeholder");
      });
      this.activeFeature = filteredFeatures[0];
      this.placeholderFeature = placeholderDefault || null;
    }
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.Custom60in.SmallCornerShelf;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }

}
